export default "__VITE_ASSET__CXPKGcL4__"